'use strict';

module.exports = function cognitoModels(cognitoLib, config, goldApi, authenticationModel, reauthenticator, navigatorShim, optional) {
	if (!cognitoLib || !config || !config.cognito || !goldApi || !authenticationModel || !navigatorShim) {
		throw new Error('invalid-args');
	}
	const cognitoIdentityShim = new cognitoLib.CognitoIdentityShim(config.cognito),
		cognitoApi = new cognitoLib.CognitoApi(goldApi, cognitoIdentityShim),
		cognitoAuthenticator = new cognitoLib.CognitoAuthenticator(cognitoApi, authenticationModel, navigatorShim, optional),
		cognitoModel = new cognitoLib.CognitoModel(authenticationModel, cognitoAuthenticator, cognitoApi);

	reauthenticator.addAuthenticator(cognitoAuthenticator);
	reauthenticator.setDefaultProviderName(cognitoAuthenticator.providerName());
	return {
		cognitoIdentityShim: cognitoIdentityShim,
		cognitoApi: cognitoApi,
		cognitoAuthenticator: cognitoAuthenticator,
		cognitoModel: cognitoModel
	};
};
